// 所属服务 serviceTool 业务工具,publicTool 公共工具
const service = "serviceTool";

// 前台路由
const web_routers = undefined;

// 后台路由
const cms_routers = [
  {
    path: "mobileLayout",
    name: "mobileLayout",
    component: () =>
      import(/* webpackChunkName: "[request]" */ "../layouts/Index.vue"),
    redirect: { name: "moduleConfig" },
    children: [
      {
        path: "moduleConfig",
        name: "moduleConfig",
        meta: {
          title: "模块配置",
          icon: "icon-tubiao01",
        },
        component: () =>
          import(
            /* webpackChunkName: "[request]" */ "../views/backstage/moduleConfig/Index.vue"
          ),
      },
    ],
  },
];

export default {
  service,
  web: web_routers,
  cms: cms_routers,
};
